import React,{useRef,useState,useEffect} from 'react';
import { HomeChart } from '../../Components/Chart';
import {DataTable} from '../../Components'
import { FaRegUser,FaInfo  } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { Controller, set, useForm } from "react-hook-form";

import {NumberFormat,MobileFormat,DateThaiFormat,DateFormat,DateThai,GetRole, TimeFormat,APIURL} from '../../Utils/Function';
import {} from '../../Utils/Status'
import { createRoot } from 'react-dom/client';
import ThaiDatePicker from '../../Components/ThaiDatePicker';
import moment from 'moment';
import Swal from 'sweetalert2';
import API from '../../API';
import '../../Assets/CSS/TALFC.css';

const PageSummary =()=> {
    const RedirectTo = useNavigate()
    const { register, getValues, setValue } = useForm();
    const [_Summary,setSummary] = useState(null);
    const [_Date,setDate] = useState(new Date());
    useEffect(() => {
        _Load();
        const intervalId = setInterval(() => {
            _Load(_Date);
        }, 600000);

        return () => {
            clearInterval(intervalId);
        };
    }, []);


    const _Load = async(Date) =>{
        const _D = moment((Date));
        Swal.showLoading();
        API({method : "get",url:"/Report/Daily?Year="+_D.year()+"&Month="+(_D.month()+1)+"&Day="+_D.date()}).then(res=>{
            Swal.close();
            if (!res.data.Status) {
                Swal.fire({
                    title: res.data.Message,
                    icon: 'error'
                });
                return;
            }
            setSummary(res.data.Data);
        }).catch(res => {
            Swal.fire({
                title: res,
                icon: 'error'
            });
            return;
        });
    }
    const _GetDate = (date)=>{

    }
    return (
        <>
        <React.Fragment>
            <div className='container-fluid'>
                <div className="row mt-2 mb-2">
                    <div className='col-12 text-end'>
                        <ThaiDatePicker className='form-control text-center' selected={_Date} onChange={(date) => { setDate(date); setTimeout(() => {_Load(date);}, 200); }} selectsStart startDate={_Date} maxDate={new Date()} />
                    </div>
                </div>
                <div className='row justify-content-center'>
                    <div className='col-7'>
                        <div className='row'>
                            <div className='col-lg-4 mt-2 mb-2'>
                                <div className='card'>
                                    <div className='card-header'>
                                        <h3 className='card-title'>รายงานสรุปเติมเงิน</h3>
                                    </div>
                                    <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-12 text-center'>
                                                <h3>{NumberFormat((_Summary != null ? _Summary.Topup:0))}</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-4 mt-2 mb-2'>
                                <div className='card'>
                                    <div className='card-header'>
                                        <h3 className='card-title'>ยอดเงินคงเหลือในระบบ</h3>
                                    </div>
                                    <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-12 text-center'>
                                                <h3>{NumberFormat((_Summary != null ? _Summary.Balance:0))}</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-4 mt-2 mb-2'>
                                <div className='card'>
                                    <div className='card-header'>
                                        <h3 className='card-title'>รายงานสรุปยอดขาย</h3>
                                    </div>
                                    <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-12 text-center'>
                                                <h3>{NumberFormat((_Summary != null ? _Summary.Income:0))}</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-4 mt-2 mb-2'>
                                <div className='card'>
                                    <div className='card-header'>
                                        <h3 className='card-title'>ยอดคืนบัตร</h3>
                                    </div>
                                    <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-12 text-center'>
                                                <h3>{NumberFormat((_Summary != null ? _Summary.Refund:0))}</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-4 mt-2 mb-2'>
                                <div className='card'>
                                    <div className='card-header'>
                                        <h3 className='card-title'>ส่วนแบ่ง</h3>
                                    </div>
                                    <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-12 text-center'>
                                                <h3>{NumberFormat((_Summary != null ? _Summary.GPShare:0))}</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-4 mt-2 mb-2'>
                                <div className='card'>
                                    <div className='card-header'>
                                        <h3 className='card-title'>จำนวนรายการขาย</h3>
                                    </div>
                                    <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-12 text-center'>
                                                <h3>{NumberFormat((_Summary != null ? _Summary.Transaction:0))}</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-5 mt-2 mb-2'>
                        <div className='card '>
                            <div className='card-header'>
                                <h3 className='card-title'>สถานะรอบบัญชี :: {_Summary != null ? DateThai(_Summary.Date):""}</h3>
                            </div>
                            <div className='card-body'>
                                <div className='row'>
                                    <div className='col-12'>
                                        <table className='table'>
                                            <thead>
                                                <tr>
                                                    <th className='text-center'>วันที่เริ่ม</th>
                                                    <th className='text-center'>ชื่อเจ้าหน้าที่</th>
                                                    <th className='text-center'>ยอดเติมเงิน</th>
                                                    <th className='text-center'>สถานะ</th>

                                                    <th className='text-center'>#</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(_Summary != null && _Summary.Shift != null ? _Summary.Shift.map((v,i)=>(
                                                    <tr key={i}>
                                                        <td className='text-center'>{DateThaiFormat(v.ShiftTimeStart,true)}</td>
                                                        <td className='text-center'>{v.Name}</td>
                                                        <td className='text-center'>{NumberFormat(v.TopupBalance)}</td>
                                                        <td className='text-center'>{v.ShiftTimeEnd != null ? <label className='text-danger'>ปิด</label>:<label className='text-success'>เปิด</label>}</td>

                                                        <td className='text-center'></td>
                                                    </tr>
                                                )):"")}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row justify-content-center mt-2'>
                    <div className='col-12 mt-2 mb-2'>
                        <div className='card '>
                            <div className='card-header'>
                                <h3 className='card-title'>สถานะยอดขาย :: {_Summary != null ? DateThai(_Summary.Date):""}</h3>
                            </div>
                            <div className='card-body'>
                                <div className='row'>
                                    <div className='col-12'>
                                        <table className='table'>
                                            <thead>
                                                <tr>
                                                    <th className='text-center'>รหัสร้านค้า</th>
                                                    <th className='text-center'>ชื่อร้านค้า</th>
                                                    <th className='text-center'>จำนวนรายการ</th>
                                                    <th className='text-center'>ยอดขาย</th>
                                                    <th className='text-center'>ส่วนแบ่ง</th>
                                                    <th className='text-center'>ยอดเงินสรุป</th>
                                                    <th className='text-center'>#</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(_Summary != null && _Summary.Store != null ? _Summary.Store.map((v, i)=>(
                                                    <tr key={i}>
                                                        <td className='text-center'>{v.StoreCode}</td>
                                                        <td className='text-center'>{v.StoreName}</td>
                                                        <td className='text-center'>{NumberFormat(v.Transaction)}</td>
                                                        <td className='text-center'>{NumberFormat(v.Income)}</td>
                                                        <td className='text-center'>{NumberFormat(v.GPShare)}</td>
                                                        <td className='text-center'>{NumberFormat(v.Balance)}</td>
                                                        <td className='text-center'></td>
                                                    </tr>
                                                )):"")}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
        </>
    )
}

export default React.memo(PageSummary)